
export const menuData = [
  {
    category: 'Hot Pot',
    icon: 'ri-fire-line',
    items: [
      {
        name: 'Classic Spicy Hot Pot',
        price: '38.00',
        description: 'Authentic Sichuan spicy broth slow-cooked with premium tallow and over 20 aromatic spices. Served with fresh vegetables, handmade meatballs, and select beef slices — bold, numbing, and utterly satisfying.',
        image: 'https://public.readdy.ai/ai/img_res/97c3bbb3c2e826be3e5a45fcb68d21fd.jpg',
        spicy: true
      },
      {
        name: 'Tomato Broth Hot Pot',
        price: '35.00',
        description: 'A light and tangy broth made from fresh tomatoes, paired with seafood, tofu, glass noodles, and seasonal vegetables. Refreshing, non-greasy, and perfect for all ages.',
        image: 'https://readdy.ai/api/search-image?query=tomato%20soup%20hot%20pot%20with%20bright%20red%20tomato%20broth%20in%20elegant%20ceramic%20pot%20featuring%20fresh%20shrimp%20tofu%20cubes%20green%20vegetables%20on%20clean%20light%20cream%20background%20healthy%20appetizing%20presentation&width=400&height=400&seq=menu-hotpot-002&orientation=squarish',
        spicy: false
      },
      {
        name: 'Wild Mushroom Wellness Hot Pot',
        price: '36.00',
        description: 'A nourishing blend of premium matsutake, porcini, and termite mushrooms, enriched with goji berries and Chinese herbs. The broth is naturally sweet, umami-rich, and deeply restorative.',
        image: 'https://readdy.ai/api/search-image?query=mushroom%20herbal%20hot%20pot%20with%20clear%20golden%20broth%20filled%20with%20various%20premium%20mushrooms%20herbs%20goji%20berries%20in%20ceramic%20pot%20on%20soft%20beige%20background%20natural%20healthy%20ingredients%20wellness&width=400&height=400&seq=menu-hotpot-003&orientation=squarish',
        spicy: false
      },
      {
        name: 'Yin Yang Dual Flavor Hot Pot',
        price: '42.00',
        description: 'One pot, two flavors — half spicy Sichuan broth, half mild clear soup. Comes with a premium selection of meats and seafood, satisfying every palate at the table.',
        image: 'https://readdy.ai/api/search-image?query=dual%20flavor%20hot%20pot%20divided%20into%20two%20sections%20red%20spicy%20broth%20on%20one%20side%20white%20mild%20broth%20on%20other%20side%20in%20yin%20yang%20shaped%20pot%20on%20light%20background%20showing%20contrast%20variety&width=400&height=400&seq=menu-hotpot-004&orientation=squarish',
        spicy: true
      },
      {
        name: 'Coconut Curry Hot Pot',
        price: '40.00',
        description: 'A Southeast Asian-inspired broth made with creamy coconut milk and aromatic curry. Paired with shrimp, fish balls, and fresh vegetables for a rich and fragrant experience.',
        image: 'https://readdy.ai/api/search-image?query=coconut%20curry%20hot%20pot%20with%20creamy%20golden%20yellow%20broth%20in%20modern%20pot%20with%20shrimp%20fish%20balls%20vegetables%20on%20clean%20white%20background%20southeast%20asian%20fusion%20cuisine%20appetizing&width=400&height=400&seq=menu-hotpot-005&orientation=squarish',
        spicy: false
      },
      {
        name: 'Pork Bone Milky Broth Hot Pot',
        price: '37.00',
        description: 'Pork bones slow-simmered for eight hours to create a rich, milky white broth. Served with handmade meatballs, tofu, and seasonal greens — warming, nourishing, and deeply comforting.',
        image: 'https://readdy.ai/api/search-image?query=pork%20bone%20broth%20hot%20pot%20with%20milky%20white%20creamy%20soup%20in%20clay%20pot%20surrounded%20by%20meatballs%20tofu%20vegetables%20on%20neutral%20background%20rich%20hearty%20warming%20comfort%20food&width=400&height=400&seq=menu-hotpot-006&orientation=squarish',
        spicy: false
      }
    ]
  },
  {
    category: 'Malatang',
    icon: 'ri-bowl-line',
    items: [
      {
        name: 'Classic Malatang',
        price: '22.00',
        description: 'Choose your own ingredients and cook them in our signature spicy numbing broth. Topped with sesame paste, crushed peanuts, and fresh cilantro — one bowl to satisfy every craving.',
        image: 'https://readdy.ai/api/search-image?query=classic%20malatang%20spicy%20soup%20with%20various%20ingredients%20skewers%20vegetables%20tofu%20noodles%20in%20red%20spicy%20broth%20in%20large%20bowl%20on%20light%20background%20authentic%20chinese%20street%20food&width=400&height=400&seq=menu-mlt-001&orientation=squarish',
        spicy: true
      },
      {
        name: 'Bone Broth Malatang',
        price: '25.00',
        description: 'A rich pork bone stock base infused with our house chili oil. Choose from a wide variety of fresh ingredients for a hearty, flavorful bowl packed with nutrition.',
        image: 'https://readdy.ai/api/search-image?query=bone%20broth%20malatang%20with%20rich%20milky%20soup%20base%20and%20red%20chili%20oil%20with%20various%20ingredients%20vegetables%20meat%20balls%20noodles%20in%20bowl%20on%20clean%20background%20hearty%20chinese%20dish&width=400&height=400&seq=menu-mlt-002&orientation=squarish',
        spicy: true
      },
      {
        name: 'Clear Broth Malatang',
        price: '20.00',
        description: 'A light and savory broth with no heat — mild, clean, and wholesome. Pick your favorite fresh ingredients and enjoy with our special dipping sauce. Great for the whole family.',
        image: 'https://readdy.ai/api/search-image?query=clear%20soup%20malatang%20with%20light%20golden%20broth%20various%20fresh%20vegetables%20tofu%20mushrooms%20noodles%20in%20white%20bowl%20on%20pale%20background%20healthy%20mild%20chinese%20hot%20pot%20style%20dish&width=400&height=400&seq=menu-mlt-003&orientation=squarish',
        spicy: false
      },
      {
        name: 'Dry Sesame Sauce Malatang',
        price: '23.00',
        description: 'No broth — just a bold mix of rich sesame paste, chili oil, and Sichuan peppercorn oil tossed with your chosen ingredients. Creamy, spicy, and intensely flavorful.',
        image: 'https://readdy.ai/api/search-image?query=sesame%20sauce%20mixed%20malatang%20dry%20style%20with%20thick%20sesame%20paste%20coating%20various%20ingredients%20vegetables%20noodles%20in%20bowl%20topped%20with%20peanuts%20green%20onions%20on%20light%20background&width=400&height=400&seq=menu-mlt-004&orientation=squarish',
        spicy: true
      }
    ]
  },
  {
    category: 'BBQ & Grill',
    icon: 'ri-restaurant-line',
    items: [
      {
        name: 'Lamb Skewers',
        price: '18.00',
        description: 'Tender Xinjiang lamb marinated with cumin and chili, grilled over charcoal until crispy outside and juicy inside. Fragrant, bold, and irresistible.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20lamb%20skewers%20with%20charred%20edges%20sprinkled%20with%20cumin%20red%20chili%20flakes%20arranged%20on%20white%20plate%20light%20background%20xinjiang%20style%20barbecue%20smoky%20aroma&width=400&height=400&seq=menu-bbq-001&orientation=squarish',
        spicy: true
      },
      {
        name: 'Beef Skewers',
        price: '19.00',
        description: 'Premium beef tenderloin marinated in house spices and grilled to golden perfection. Juicy, tender, and full of savory depth.',
        image: 'https://readdy.ai/api/search-image?query=beef%20skewers%20with%20juicy%20grilled%20beef%20cubes%20showing%20char%20marks%20and%20spices%20on%20bamboo%20sticks%20arranged%20on%20plate%20simple%20light%20background%20tender%20meat%20grill%20marks&width=400&height=400&seq=menu-bbq-002&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Chicken Wings',
        price: '15.00',
        description: 'Chicken wings marinated in honey and soy sauce, grilled until the skin is golden and crispy. Finished with sesame seeds and scallions — sweet, savory, and crowd-pleasing.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20chicken%20wings%20with%20glossy%20caramelized%20coating%20sprinkled%20with%20sesame%20seeds%20green%20onions%20on%20white%20plate%20pale%20background%20golden%20brown%20color%20appetizing&width=400&height=400&seq=menu-bbq-003&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Eggplant',
        price: '12.00',
        description: 'Whole eggplant charcoal-grilled until soft and smoky, then topped with garlic sauce, sesame paste, and fresh cilantro. A classic vegetarian BBQ favorite.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20eggplant%20split%20open%20topped%20with%20garlic%20sauce%20sesame%20paste%20cilantro%20on%20white%20plate%20neutral%20background%20soft%20tender%20texture%20flavorful%20toppings&width=400&height=400&seq=menu-bbq-004&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Corn',
        price: '8.00',
        description: 'Fresh sweet corn grilled over charcoal and brushed with butter and honey. Caramelized, fragrant, and one of the most beloved BBQ snacks.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20corn%20on%20the%20cob%20with%20golden%20charred%20kernels%20brushed%20with%20butter%20and%20honey%20on%20plate%20light%20background%20sweet%20caramelized%20bbq%20corn%20appetizing&width=400&height=400&seq=menu-bbq-005&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Pork Belly',
        price: '16.00',
        description: 'Three-layer pork belly marinated in our secret sauce and slow-grilled over charcoal. Crispy skin, tender meat, and rich aroma — indulgent without being heavy.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20pork%20belly%20slices%20with%20crispy%20skin%20and%20tender%20meat%20showing%20beautiful%20layers%20on%20plate%20with%20light%20background%20caramelized%20glaze%20appetizing%20bbq&width=400&height=400&seq=menu-bbq-006&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Chinese Chives',
        price: '9.00',
        description: 'Bundles of fresh chives grilled until lightly charred, then dusted with cumin and chili powder. Fragrant, mildly spicy, and a must-order vegetable at any BBQ.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20chinese%20chives%20bundles%20with%20charred%20edges%20sprinkled%20with%20cumin%20and%20chili%20powder%20on%20plate%20light%20background%20fragrant%20vegetable%20bbq&width=400&height=400&seq=menu-bbq-007&orientation=squarish',
        spicy: true
      },
      {
        name: 'Grilled Whole Squid',
        price: '20.00',
        description: 'Whole fresh squid grilled over charcoal and brushed with our house sauce. Lightly charred on the outside, chewy and flavorful inside — a seafood BBQ classic.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20whole%20squid%20with%20charred%20marks%20brushed%20with%20savory%20sauce%20on%20plate%20light%20background%20seafood%20bbq%20chewy%20texture%20appetizing&width=400&height=400&seq=menu-bbq-008&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Tofu',
        price: '10.00',
        description: 'Firm tofu grilled until golden and crispy on the outside, then drizzled with spicy garlic sauce. Crispy outside, silky inside — a perfect vegetarian option.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20tofu%20cubes%20with%20golden%20crispy%20exterior%20topped%20with%20garlic%20chili%20sauce%20on%20plate%20neutral%20background%20vegetarian%20bbq%20appetizing&width=400&height=400&seq=menu-bbq-009&orientation=squarish',
        spicy: true
      },
      {
        name: 'Grilled Shiitake Mushrooms',
        price: '11.00',
        description: 'Thick, meaty shiitake mushrooms grilled until juicy and fragrant, topped with minced garlic and scallions. Umami-rich and naturally satisfying.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20shiitake%20mushrooms%20with%20juicy%20caps%20topped%20with%20garlic%20and%20green%20onions%20on%20plate%20light%20background%20umami%20rich%20vegetarian%20bbq&width=400&height=400&seq=menu-bbq-010&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled King Prawns',
        price: '22.00',
        description: 'Fresh large prawns marinated in garlic butter and grilled until the shells are lightly charred. Sweet, springy, and absolutely delicious — a must for seafood lovers.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20large%20prawns%20with%20charred%20shells%20brushed%20with%20garlic%20butter%20on%20plate%20light%20background%20fresh%20seafood%20bbq%20appetizing%20pink%20color&width=400&height=400&seq=menu-bbq-011&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Pork Trotters',
        price: '25.00',
        description: 'Braised then grilled pork trotters — crispy skin, fall-off-the-bone meat, and rich collagen. Glazed with our house sauce for a deeply savory, satisfying bite.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20braised%20pork%20trotters%20with%20crispy%20skin%20and%20tender%20meat%20glazed%20with%20savory%20sauce%20on%20plate%20neutral%20background%20rich%20collagen%20bbq&width=400&height=400&seq=menu-bbq-012&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Whole Chicken Leg',
        price: '17.00',
        description: 'A whole chicken leg marinated in aromatic spices and slow-grilled over charcoal. Crispy skin, juicy meat, finished with cumin and chili for extra flavor.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20whole%20chicken%20leg%20with%20crispy%20golden%20skin%20and%20juicy%20meat%20sprinkled%20with%20spices%20on%20plate%20light%20background%20appetizing%20bbq&width=400&height=400&seq=menu-bbq-013&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Beef Tongue',
        price: '28.00',
        description: 'Premium beef tongue thinly sliced and marinated in soy sauce and mirin, then quickly grilled over high heat. Silky, tender, and incredibly juicy — a premium BBQ cut.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20beef%20tongue%20thin%20slices%20with%20beautiful%20grill%20marks%20on%20plate%20light%20background%20premium%20bbq%20tender%20juicy%20japanese%20style&width=400&height=400&seq=menu-bbq-014&orientation=squarish',
        spicy: false
      },
      {
        name: 'Bacon-Wrapped Rolls',
        price: '14.00',
        description: 'Thin-cut bacon wrapped around enoki mushrooms or asparagus, grilled until the bacon is crispy and the filling is tender. Savory, bite-sized, and utterly addictive.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20bacon%20wrapped%20enoki%20mushrooms%20or%20asparagus%20with%20crispy%20bacon%20exterior%20on%20plate%20light%20background%20savory%20appetizing%20bite%20sized%20bbq&width=400&height=400&seq=menu-bbq-015&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Lamb Rack',
        price: '45.00',
        description: 'A full rack of Xinjiang lamb marinated with cumin and rosemary, slow-grilled over charcoal until the meat falls off the bone. Rich, aromatic, and the king of the grill.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20lamb%20rack%20with%20beautiful%20char%20marks%20and%20herbs%20on%20plate%20light%20background%20premium%20xinjiang%20lamb%20ribs%20cumin%20rosemary%20aromatic&width=400&height=400&seq=menu-bbq-016&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Chicken Hearts',
        price: '13.00',
        description: 'Fresh chicken hearts marinated in cumin and chili, grilled until crispy outside and tender inside. Springy, flavorful, and a popular street-style skewer.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20chicken%20hearts%20on%20skewers%20with%20cumin%20and%20chili%20seasoning%20charred%20exterior%20on%20plate%20light%20background%20popular%20street%20food%20bbq&width=400&height=400&seq=menu-bbq-017&orientation=squarish',
        spicy: true
      },
      {
        name: 'Grilled Beef Ribs',
        price: '38.00',
        description: 'Beef ribs marinated in our secret sauce for 24 hours, then slow-grilled over charcoal. Fall-off-the-bone tender with a deep, caramelized glaze.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20beef%20ribs%20with%20beautiful%20caramelized%20glaze%20and%20char%20marks%20on%20plate%20light%20background%20tender%20fall%20off%20bone%20bbq%20ribs%20appetizing&width=400&height=400&seq=menu-bbq-018&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Whole Cauliflower',
        price: '10.00',
        description: 'A whole cauliflower grilled until the outside is golden and charred, brushed with spiced butter. Crispy on the outside, soft and tender inside — a trendy vegetarian BBQ dish.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20whole%20cauliflower%20with%20golden%20charred%20exterior%20brushed%20with%20spiced%20butter%20on%20plate%20light%20background%20vegetarian%20bbq%20trendy&width=400&height=400&seq=menu-bbq-019&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Pork Collar',
        price: '22.00',
        description: 'Well-marbled pork collar marinated in Thai-style sauce and grilled to golden perfection. Smooth, tender, and packed with flavor.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20pork%20collar%20with%20beautiful%20marbling%20and%20char%20marks%20sliced%20on%20plate%20light%20background%20thai%20style%20marinade%20tender%20juicy%20bbq&width=400&height=400&seq=menu-bbq-020&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Scallops with Garlic Vermicelli',
        price: '24.00',
        description: 'Fresh scallops in the shell topped with garlic vermicelli and grilled until juicy and fragrant. A classic seafood BBQ dish bursting with garlic aroma.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20scallops%20in%20shell%20with%20garlic%20vermicelli%20topping%20on%20plate%20light%20background%20seafood%20bbq%20garlic%20aroma%20appetizing&width=400&height=400&seq=menu-bbq-021&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Chicken Gizzards',
        price: '12.00',
        description: 'Fresh chicken gizzards marinated in cumin and chili, grilled until crispy outside and chewy inside. Crunchy, bold, and a perfect pairing with drinks.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20chicken%20gizzards%20on%20skewers%20with%20cumin%20chili%20seasoning%20crispy%20exterior%20on%20plate%20light%20background%20popular%20bbq%20snack&width=400&height=400&seq=menu-bbq-022&orientation=squarish',
        spicy: true
      },
      {
        name: 'Grilled Potato Slices',
        price: '9.00',
        description: 'Fresh potato slices grilled until both sides are golden, then sprinkled with cumin, chili powder, and scallions. Crispy outside, soft inside, and wonderfully aromatic.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20potato%20slices%20with%20golden%20crispy%20exterior%20sprinkled%20with%20cumin%20chili%20and%20green%20onions%20on%20plate%20light%20background%20street%20food%20bbq&width=400&height=400&seq=menu-bbq-023&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Crispy Chicken Skin',
        price: '11.00',
        description: 'Chicken skin seasoned with salt and pepper, grilled until perfectly crispy, then dusted with cumin and chili. Crunchy, savory, and dangerously snackable.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20crispy%20chicken%20skin%20skewers%20with%20golden%20color%20sprinkled%20with%20spices%20on%20plate%20light%20background%20crunchy%20bbq%20snack&width=400&height=400&seq=menu-bbq-024&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Beef Patty',
        price: '16.00',
        description: 'Handmade beef patty seasoned with onion and spices, grilled until both sides are golden. Served with our special sauce — juicy, flavorful, and satisfying.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20beef%20patty%20with%20beautiful%20char%20marks%20juicy%20interior%20on%20plate%20light%20background%20handmade%20burger%20patty%20bbq%20appetizing&width=400&height=400&seq=menu-bbq-025&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Chicken Breast Skewers',
        price: '14.00',
        description: 'Chicken breast marinated in lemon and herbs, grilled to golden perfection. Lean, tender, and healthy — a top choice for fitness-conscious diners.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20chicken%20breast%20skewers%20with%20golden%20color%20lemon%20herb%20marinade%20on%20plate%20light%20background%20healthy%20lean%20protein%20bbq&width=400&height=400&seq=menu-bbq-026&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Pork Tenderloin Skewers',
        price: '13.00',
        description: 'Pork tenderloin marinated in honey and soy sauce, grilled until golden. Sweet, savory, and tender — a timeless BBQ classic.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20pork%20tenderloin%20skewers%20with%20honey%20soy%20glaze%20golden%20color%20on%20plate%20light%20background%20sweet%20savory%20bbq%20tender&width=400&height=400&seq=menu-bbq-027&orientation=squarish',
        spicy: false
      },
      {
        name: 'Grilled Green Peppers',
        price: '8.00',
        description: 'Whole fresh green peppers grilled until the skin is lightly charred and the flesh is soft. Seasoned simply with garlic and salt — clean, mildly spicy, and refreshing.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20whole%20green%20peppers%20with%20charred%20skin%20on%20plate%20light%20background%20simple%20vegetable%20bbq%20garlic%20salt%20seasoning&width=400&height=400&seq=menu-bbq-028&orientation=squarish',
        spicy: true
      },
      {
        name: 'Grilled Chicken Neck',
        price: '12.00',
        description: 'Chicken necks marinated in our house brine and grilled until the skin is crispy and the meat falls off the bone. Spicy, aromatic, and a beloved BBQ snack.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20chicken%20neck%20with%20crispy%20skin%20and%20spicy%20seasoning%20on%20plate%20light%20background%20popular%20chinese%20bbq%20snack&width=400&height=400&seq=menu-bbq-029&orientation=squarish',
        spicy: true
      },
      {
        name: 'Grilled Beef Meatballs',
        price: '15.00',
        description: 'Hand-pounded beef meatballs marinated in cumin and chili, grilled until golden on the outside. Crispy outside, springy and juicy inside — a crowd favorite.',
        image: 'https://readdy.ai/api/search-image?query=grilled%20beef%20meatballs%20on%20skewers%20with%20golden%20exterior%20cumin%20seasoning%20on%20plate%20light%20background%20handmade%20bouncy%20texture%20bbq&width=400&height=400&seq=menu-bbq-030&orientation=squarish',
        spicy: false
      }
    ]
  },
  {
    category: 'Chicken & Pork',
    icon: 'ri-knife-line',
    items: [
      {
        name: 'Kung Pao Chicken',
        price: '22.00',
        description: 'A Sichuan classic — diced chicken stir-fried with peanuts, dried chilies, and scallions in a tangy, mildly spicy sauce. One of China\'s most beloved dishes.',
        image: 'https://readdy.ai/api/search-image?query=kung%20pao%20chicken%20with%20diced%20chicken%20peanuts%20dried%20chilies%20green%20onions%20in%20glossy%20sauce%20on%20white%20plate%20light%20background%20classic%20sichuan%20dish&width=400&height=400&seq=menu-chicken-001&orientation=squarish',
        spicy: true
      },
      {
        name: 'Sichuan Saliva Chicken',
        price: '24.00',
        description: 'Poached chicken drizzled with our house red chili oil, Sichuan peppercorn oil, and garlic sauce. Numbing, spicy, and melt-in-your-mouth — a Sichuan cold dish icon.',
        image: 'https://readdy.ai/api/search-image?query=sichuan%20saliva%20chicken%20with%20poached%20chicken%20slices%20covered%20in%20red%20chili%20oil%20sesame%20sauce%20on%20plate%20light%20background%20classic%20cold%20dish&width=400&height=400&seq=menu-chicken-002&orientation=squarish',
        spicy: true
      },
      {
        name: 'Sweet & Sour Pork',
        price: '20.00',
        description: 'Crispy battered pork tenderloin tossed in a glossy sweet and sour sauce. Crunchy outside, tender inside, and perfectly balanced in flavor — a timeless family favorite.',
        image: 'https://readdy.ai/api/search-image?query=sweet%20and%20sour%20pork%20tenderloin%20with%20golden%20crispy%20coating%20in%20glossy%20red%20sweet%20sour%20sauce%20on%20white%20plate%20light%20background%20classic%20chinese%20dish&width=400&height=400&seq=menu-pork-001&orientation=squarish',
        spicy: false
      },
      {
        name: 'Twice-Cooked Pork',
        price: '22.00',
        description: 'Pork belly boiled then stir-fried with green garlic and spicy bean paste. Rich, aromatic, and satisfying — one of Sichuan\'s most iconic home-style dishes.',
        image: 'https://readdy.ai/api/search-image?query=twice%20cooked%20pork%20with%20sliced%20pork%20belly%20green%20garlic%20leeks%20in%20spicy%20bean%20paste%20sauce%20on%20white%20plate%20light%20background%20sichuan%20classic&width=400&height=400&seq=menu-pork-002&orientation=squarish',
        spicy: true
      },
      {
        name: 'Chongqing Spicy Chicken',
        price: '26.00',
        description: 'Crispy fried chicken pieces buried in a mountain of dried chilies and Sichuan peppercorns. Fiery, numbing, and addictively crunchy — a Chongqing signature.',
        image: 'https://readdy.ai/api/search-image?query=chongqing%20spicy%20chicken%20with%20crispy%20chicken%20pieces%20buried%20in%20dried%20chilies%20and%20sichuan%20peppercorns%20on%20plate%20light%20background%20fiery%20red%20color&width=400&height=400&seq=menu-chicken-003&orientation=squarish',
        spicy: true
      },
      {
        name: 'Dongpo Braised Pork',
        price: '28.00',
        description: 'Pork belly slow-braised in Shaoxing wine, soy sauce, and rock sugar until meltingly tender. A Hangzhou classic named after the legendary poet Su Dongpo.',
        image: 'https://readdy.ai/api/search-image?query=dongpo%20pork%20braised%20pork%20belly%20with%20glossy%20caramelized%20sauce%20in%20ceramic%20bowl%20light%20background%20hangzhou%20classic%20dish%20tender%20melt%20in%20mouth&width=400&height=400&seq=menu-pork-003&orientation=squarish',
        spicy: false
      },
      {
        name: 'White Cut Chicken',
        price: '25.00',
        description: 'Free-range chicken gently poached at low temperature to preserve its natural juices. Silky skin, tender meat, served with ginger-scallion dipping sauce — a Cantonese classic.',
        image: 'https://readdy.ai/api/search-image?query=white%20cut%20chicken%20cantonese%20style%20with%20smooth%20skin%20sliced%20on%20plate%20with%20ginger%20scallion%20dipping%20sauce%20light%20background%20classic%20guangdong%20dish&width=400&height=400&seq=menu-chicken-004&orientation=squarish',
        spicy: false
      },
      {
        name: 'Red-Braised Pork Belly',
        price: '24.00',
        description: 'Pork belly slow-braised in soy sauce, rock sugar, and star anise until glossy and deeply caramelized. Rich, tender, and melt-in-your-mouth — a Chinese comfort food staple.',
        image: 'https://readdy.ai/api/search-image?query=red%20braised%20pork%20belly%20with%20glossy%20dark%20sauce%20and%20beautiful%20layers%20in%20bowl%20light%20background%20classic%20chinese%20comfort%20food%20caramelized&width=400&height=400&seq=menu-pork-004&orientation=squarish',
        spicy: false
      },
      {
        name: 'Beer-Braised Duck',
        price: '30.00',
        description: 'Duck slow-braised in beer and spicy bean paste until tender and deeply flavorful. Mildly spicy with a hint of sweetness — a perfect pairing with rice or drinks.',
        image: 'https://readdy.ai/api/search-image?query=beer%20braised%20duck%20with%20rich%20dark%20sauce%20and%20tender%20meat%20pieces%20in%20clay%20pot%20light%20background%20savory%20chinese%20braised%20dish&width=400&height=400&seq=menu-chicken-005&orientation=squarish',
        spicy: true
      },
      {
        name: 'Steamed Pork with Rice Flour',
        price: '20.00',
        description: 'Pork belly coated in toasted rice flour and steamed with taro until soft and fragrant. The rice and pork aromas meld beautifully — a beloved Hunan traditional dish.',
        image: 'https://readdy.ai/api/search-image?query=steamed%20pork%20with%20rice%20flour%20coating%20and%20taro%20in%20bamboo%20steamer%20light%20background%20hunan%20traditional%20dish%20fragrant%20tender&width=400&height=400&seq=menu-pork-005&orientation=squarish',
        spicy: false
      },
      {
        name: 'Three Cup Chicken',
        price: '26.00',
        description: 'Chicken braised in equal parts soy sauce, rice wine, and sesame oil, finished with fresh Thai basil. Deeply aromatic and intensely savory — a Taiwanese classic.',
        image: 'https://readdy.ai/api/search-image?query=three%20cup%20chicken%20taiwanese%20style%20with%20dark%20glossy%20sauce%20basil%20leaves%20in%20clay%20pot%20light%20background%20aromatic%20classic%20dish&width=400&height=400&seq=menu-chicken-006&orientation=squarish',
        spicy: false
      },
      {
        name: 'Pork Belly with Preserved Mustard Greens',
        price: '26.00',
        description: 'Layers of pork belly and preserved mustard greens steamed together until meltingly tender. Savory, umami-rich, and perfectly balanced — a Hakka heritage dish.',
        image: 'https://readdy.ai/api/search-image?query=braised%20pork%20belly%20with%20preserved%20mustard%20greens%20layered%20in%20bowl%20light%20background%20hakka%20traditional%20dish%20savory%20umami&width=400&height=400&seq=menu-pork-006&orientation=squarish',
        spicy: false
      },
      {
        name: 'Spicy Fried Chicken Leg',
        price: '22.00',
        description: 'Chicken legs marinated in chili, Sichuan peppercorn, and garlic, then fried until golden and crispy. Numbing, spicy, and incredibly satisfying — a young crowd favorite.',
        image: 'https://readdy.ai/api/search-image?query=spicy%20fried%20chicken%20leg%20with%20crispy%20golden%20coating%20and%20chili%20seasoning%20on%20plate%20light%20background%20popular%20chinese%20fried%20chicken&width=400&height=400&seq=menu-chicken-007&orientation=squarish',
        spicy: true
      },
      {
        name: 'Garlic Pork Slices',
        price: '18.00',
        description: 'Thinly sliced boiled pork belly drizzled with garlic paste, chili oil, and soy sauce. Mildly spicy, fresh, and aromatic — a classic Sichuan cold dish.',
        image: 'https://readdy.ai/api/search-image?query=garlic%20pork%20slices%20with%20thin%20pork%20belly%20covered%20in%20garlic%20paste%20chili%20oil%20on%20plate%20light%20background%20sichuan%20cold%20dish&width=400&height=400&seq=menu-pork-007&orientation=squarish',
        spicy: true
      },
      {
        name: 'Lemon Chicken',
        price: '24.00',
        description: 'Chicken marinated in lemon juice and lemongrass, fried until golden, then drizzled with a tangy lemon sauce. Bright, refreshing, and full of Southeast Asian flair.',
        image: 'https://readdy.ai/api/search-image?query=lemon%20chicken%20with%20crispy%20golden%20coating%20drizzled%20with%20tangy%20lemon%20sauce%20on%20plate%20light%20background%20southeast%20asian%20fusion%20fresh%20citrus&width=400&height=400&seq=menu-chicken-008&orientation=squarish',
        spicy: false
      }
    ]
  },
  {
    category: 'Beef & Lamb',
    icon: 'ri-award-line',
    items: [
      {
        name: 'Sichuan Boiled Beef',
        price: '28.00',
        description: 'Tender beef slices cooked in a spicy numbing broth, then finished with a drizzle of sizzling chili oil. Bold, fiery, and one of Sichuan\'s most iconic dishes.',
        image: 'https://readdy.ai/api/search-image?query=sichuan%20boiled%20beef%20with%20tender%20slices%20in%20spicy%20red%20broth%20topped%20with%20chili%20oil%20and%20vegetables%20in%20bowl%20light%20background%20classic%20sichuan%20dish&width=400&height=400&seq=menu-beef-001&orientation=squarish',
        spicy: true
      },
      {
        name: 'Red-Braised Beef Brisket',
        price: '32.00',
        description: 'Beef brisket slow-braised with soy sauce, star anise, and cinnamon until fall-apart tender. Served with radish in a rich, deeply savory broth — perfect for cold days.',
        image: 'https://readdy.ai/api/search-image?query=red%20braised%20beef%20brisket%20with%20tender%20chunks%20in%20dark%20rich%20sauce%20with%20radish%20in%20bowl%20light%20background%20hearty%20chinese%20braised%20dish&width=400&height=400&seq=menu-beef-002&orientation=squarish',
        spicy: false
      },
      {
        name: 'Scallion-Seared Lamb',
        price: '30.00',
        description: 'Thinly sliced lamb tenderloin wok-tossed with green onions over high heat. Tender, fragrant, and full of savory depth — a beloved northern Chinese classic.',
        image: 'https://readdy.ai/api/search-image?query=stir%20fried%20lamb%20with%20green%20onions%20tender%20lamb%20slices%20with%20scallions%20in%20savory%20sauce%20on%20plate%20light%20background%20northern%20chinese%20classic%20dish&width=400&height=400&seq=menu-lamb-001&orientation=squarish',
        spicy: false
      },
      {
        name: 'Cumin Lamb Stir-Fry',
        price: '32.00',
        description: 'Lamb slices wok-fried with cumin seeds and dried chilies over blazing heat. Aromatic, slightly charred, and intensely flavorful — a Xinjiang-style classic.',
        image: 'https://readdy.ai/api/search-image?query=cumin%20lamb%20stir%20fry%20with%20tender%20lamb%20slices%20cumin%20seeds%20dried%20chilies%20on%20plate%20light%20background%20xinjiang%20style%20aromatic%20dish&width=400&height=400&seq=menu-lamb-002&orientation=squarish',
        spicy: true
      },
      {
        name: 'Black Pepper Beef Tenderloin',
        price: '30.00',
        description: 'Tender beef strips stir-fried in a rich black pepper sauce with onions and bell peppers. Bold, aromatic, and satisfying — a fusion-style favorite.',
        image: 'https://readdy.ai/api/search-image?query=black%20pepper%20beef%20tenderloin%20with%20tender%20strips%20in%20glossy%20black%20pepper%20sauce%20with%20onions%20peppers%20on%20plate%20light%20background%20fusion%20dish&width=400&height=400&seq=menu-beef-003&orientation=squarish',
        spicy: false
      },
      {
        name: 'Hand-Grabbed Lamb',
        price: '45.00',
        description: 'A whole lamb leg slow-boiled in salted water to preserve its natural flavor. Served with cumin and chili dipping sauce — a bold, traditional Xinjiang feast.',
        image: 'https://readdy.ai/api/search-image?query=hand%20grabbed%20lamb%20whole%20leg%20boiled%20in%20salt%20water%20with%20cumin%20dipping%20sauce%20on%20plate%20light%20background%20xinjiang%20traditional%20hearty%20dish&width=400&height=400&seq=menu-lamb-003&orientation=squarish',
        spicy: false
      },
      {
        name: 'Tomato Beef Stir-Fry',
        price: '24.00',
        description: 'Fresh tomatoes and tender beef slices stir-fried together in a savory, tangy sauce. Bright, hearty, and one of the most popular home-style dishes in China.',
        image: 'https://readdy.ai/api/search-image?query=tomato%20beef%20stir%20fry%20with%20tender%20beef%20slices%20and%20fresh%20tomatoes%20in%20savory%20sauce%20on%20plate%20light%20background%20popular%20chinese%20home%20cooking&width=400&height=400&seq=menu-beef-004&orientation=squarish',
        spicy: false
      },
      {
        name: 'Braised Lamb Spine',
        price: '48.00',
        description: 'Lamb spine slow-braised in our secret spice blend until the marrow is rich and the meat is fall-off-the-bone tender. A warming northern Chinese winter specialty.',
        image: 'https://readdy.ai/api/search-image?query=braised%20lamb%20spine%20with%20rich%20dark%20broth%20and%20tender%20meat%20in%20pot%20light%20background%20northern%20chinese%20winter%20dish%20hearty%20warming&width=400&height=400&seq=menu-lamb-004&orientation=squarish',
        spicy: false
      },
      {
        name: 'Sizzling Iron Plate Beef',
        price: '35.00',
        description: 'Tender beef slices marinated in our house sauce, cooked on a scorching iron plate with onions and bell peppers. Arrives sizzling and aromatic — a dramatic tableside experience.',
        image: 'https://readdy.ai/api/search-image?query=sizzling%20beef%20on%20hot%20iron%20plate%20with%20onions%20peppers%20in%20savory%20sauce%20steaming%20on%20plate%20light%20background%20dramatic%20presentation&width=400&height=400&seq=menu-beef-005&orientation=squarish',
        spicy: false
      },
      {
        name: 'Clear-Braised Lamb Soup',
        price: '38.00',
        description: 'Lamb leg slow-simmered with radish and goji berries in a clear, naturally sweet broth. Light, nourishing, and deeply restorative — an ideal winter wellness dish.',
        image: 'https://readdy.ai/api/search-image?query=clear%20braised%20lamb%20with%20radish%20goji%20berries%20in%20light%20broth%20in%20clay%20pot%20light%20background%20nourishing%20winter%20soup%20healthy&width=400&height=400&seq=menu-lamb-005&orientation=squarish',
        spicy: false
      }
    ]
  },
  {
    category: 'Noodles',
    icon: 'ri-bowl-line',
    items: [
      {
        name: 'Braised Beef Noodle Soup',
        price: '16.00',
        description: 'Hand-pulled noodles in a rich, slow-braised beef brisket broth, topped with tender beef chunks, cilantro, and scallions. The definitive Taiwanese beef noodle experience.',
        image: 'https://readdy.ai/api/search-image?query=beef%20noodle%20soup%20with%20thick%20hand%20pulled%20noodles%20tender%20beef%20chunks%20in%20dark%20rich%20broth%20garnished%20with%20green%20onions%20cilantro%20in%20white%20bowl%20pale%20background%20comfort%20food&width=400&height=400&seq=menu-noodles-001&orientation=squarish',
        spicy: false
      },
      {
        name: 'Dan Dan Noodles',
        price: '14.00',
        description: 'A Sichuan street food classic — hand-pulled noodles topped with spicy sesame sauce, minced pork, preserved vegetables, and crushed peanuts. Numbing, bold, and unforgettable.',
        image: 'https://readdy.ai/api/search-image?query=dan%20dan%20noodles%20with%20hand%20pulled%20noodles%20covered%20in%20red%20spicy%20sauce%20topped%20with%20minced%20meat%20peanuts%20green%20onions%20in%20ceramic%20bowl%20light%20background%20sichuan%20street%20food&width=400&height=400&seq=menu-noodles-002&orientation=squarish',
        spicy: true
      },
      {
        name: 'Lanzhou Hand-Pulled Beef Noodles',
        price: '15.00',
        description: 'Traditional Lanzhou-style noodles in a clear beef bone broth, topped with beef slices, white radish, and cilantro. Clean, savory, and a proud icon of northwestern Chinese cuisine.',
        image: 'https://readdy.ai/api/search-image?query=lanzhou%20beef%20noodles%20with%20clear%20broth%20thin%20hand%20pulled%20noodles%20beef%20slices%20white%20radish%20cilantro%20in%20large%20bowl%20neutral%20background%20traditional%20northwestern%20chinese%20cuisine&width=400&height=400&seq=menu-noodles-003&orientation=squarish',
        spicy: false
      },
      {
        name: 'Cold Sesame Noodles',
        price: '13.00',
        description: 'Hand-pulled noodles tossed in a rich sesame paste with shredded cucumber, bean sprouts, and our special sauce. Cool, creamy, and refreshing — perfect for warm days.',
        image: 'https://readdy.ai/api/search-image?query=cold%20sesame%20noodles%20with%20hand%20pulled%20noodles%20coated%20in%20creamy%20tan%20sesame%20sauce%20topped%20with%20cucumber%20strips%20sesame%20seeds%20in%20white%20bowl%20clean%20background%20refreshing%20summer%20dish&width=400&height=400&seq=menu-noodles-004&orientation=squarish',
        spicy: false
      },
      {
        name: 'Beijing Zhajiang Noodles',
        price: '14.00',
        description: 'A Beijing classic — thick hand-pulled noodles topped with savory pork and soybean paste sauce, served with shredded cucumber and bean sprouts. Hearty and deeply satisfying.',
        image: 'https://readdy.ai/api/search-image?query=zhajiang%20noodles%20beijing%20style%20with%20thick%20noodles%20topped%20with%20savory%20meat%20sauce%20cucumber%20strips%20bean%20sprouts%20in%20bowl%20light%20background%20classic%20northern%20chinese%20noodles&width=400&height=400&seq=menu-noodles-005&orientation=squarish',
        spicy: false
      },
      {
        name: 'Sour & Spicy Sweet Potato Noodles',
        price: '13.00',
        description: 'Chewy sweet potato noodles in a tangy, spicy broth, topped with peanuts, cilantro, and scallions. Bright, bold, and one of Chongqing\'s most popular street snacks.',
        image: 'https://readdy.ai/api/search-image?query=sour%20spicy%20sweet%20potato%20noodles%20in%20red%20broth%20with%20peanuts%20cilantro%20in%20bowl%20light%20background%20chongqing%20street%20food%20popular%20snack&width=400&height=400&seq=menu-noodles-006&orientation=squarish',
        spicy: true
      },
      {
        name: 'Shanghai Plain Noodles',
        price: '10.00',
        description: 'Simple yet iconic Shanghai noodles in a clear broth with lard and scallions. Light, clean, and deeply comforting — a classic Shanghai breakfast staple.',
        image: 'https://readdy.ai/api/search-image?query=shanghai%20plain%20noodles%20in%20clear%20broth%20with%20lard%20and%20green%20onions%20in%20white%20bowl%20light%20background%20simple%20classic%20shanghai%20breakfast%20noodles&width=400&height=400&seq=menu-noodles-007&orientation=squarish',
        spicy: false
      },
      {
        name: 'Tomato & Egg Noodles',
        price: '12.00',
        description: 'Fresh tomatoes and scrambled eggs stir-fried into a savory sauce, served over hand-pulled noodles. Tangy, nourishing, and one of China\'s most beloved everyday noodle dishes.',
        image: 'https://readdy.ai/api/search-image?query=tomato%20egg%20noodles%20with%20fresh%20tomatoes%20scrambled%20eggs%20in%20savory%20sauce%20over%20noodles%20in%20bowl%20light%20background%20popular%20chinese%20home%20cooking%20noodles&width=400&height=400&seq=menu-noodles-008&orientation=squarish',
        spicy: false
      },
      {
        name: 'Scallion Oil Noodles',
        price: '11.00',
        description: 'Hand-pulled noodles tossed in slow-fried scallion oil with soy sauce and a touch of sugar. Fragrant, glossy, and deceptively simple — the soul of Shanghai alleyway cooking.',
        image: 'https://readdy.ai/api/search-image?query=scallion%20oil%20noodles%20with%20glossy%20coating%20and%20caramelized%20green%20onions%20in%20bowl%20light%20background%20shanghai%20style%20simple%20delicious%20noodles&width=400&height=400&seq=menu-noodles-009&orientation=squarish',
        spicy: false
      },
      {
        name: 'Spicy Wide Sweet Potato Noodles',
        price: '14.00',
        description: 'Wide sweet potato noodles in a spicy numbing broth, topped with minced beef, peanuts, and cilantro. Chewy, bold, and a Sichuan noodle specialty.',
        image: 'https://readdy.ai/api/search-image?query=spicy%20wide%20sweet%20potato%20noodles%20in%20red%20broth%20with%20minced%20beef%20peanuts%20in%20bowl%20light%20background%20sichuan%20style%20chewy%20noodles&width=400&height=400&seq=menu-noodles-010&orientation=squarish',
        spicy: true
      }
    ]
  },
  {
    category: 'Cold Dishes',
    icon: 'ri-leaf-line',
    items: [
      {
        name: 'Smashed Cucumber Salad',
        price: '8.00',
        description: 'Fresh cucumbers smashed and tossed with garlic, chili oil, vinegar, and sesame. Crisp, cool, and refreshing — a classic summer appetizer.',
        image: 'https://readdy.ai/api/search-image?query=smashed%20cucumber%20salad%20with%20cucumber%20pieces%20tossed%20in%20red%20chili%20oil%20garlic%20sesame%20seeds%20in%20white%20bowl%20clean%20background%20fresh%20appetizing%20cold%20dish&width=400&height=400&seq=menu-cold-001&orientation=squarish',
        spicy: true
      },
      {
        name: 'Fuqi Feipian (Spiced Beef Offal)',
        price: '18.00',
        description: 'Thinly sliced beef, tripe, and tongue drizzled with our house red chili oil and Sichuan peppercorn sauce. Numbing, spicy, and one of Sichuan\'s most iconic cold dishes.',
        image: 'https://readdy.ai/api/search-image?query=fuqi%20feipian%20sichuan%20cold%20beef%20offal%20with%20thin%20slices%20covered%20in%20red%20chili%20oil%20sesame%20sauce%20on%20plate%20light%20background%20classic%20sichuan%20cold%20dish&width=400&height=400&seq=menu-cold-002&orientation=squarish',
        spicy: true
      },
      {
        name: 'Cold Black Fungus Salad',
        price: '10.00',
        description: 'Blanched black wood ear mushrooms tossed with garlic, chili oil, and vinegar. Crunchy, light, and healthy — a vegetarian cold dish staple.',
        image: 'https://readdy.ai/api/search-image?query=cold%20black%20fungus%20salad%20with%20wood%20ear%20mushrooms%20in%20garlic%20chili%20oil%20dressing%20on%20plate%20light%20background%20healthy%20vegetarian%20cold%20dish&width=400&height=400&seq=menu-cold-003&orientation=squarish',
        spicy: false
      },
      {
        name: 'Century Egg Tofu',
        price: '12.00',
        description: 'Silken tofu paired with century egg, drizzled with garlic soy sauce and chili oil. Rich, savory, and mildly spicy — a Cantonese cold dish classic.',
        image: 'https://readdy.ai/api/search-image?query=century%20egg%20tofu%20with%20silken%20tofu%20and%20preserved%20egg%20topped%20with%20soy%20sauce%20garlic%20chili%20oil%20on%20plate%20light%20background%20cantonese%20cold%20dish&width=400&height=400&seq=menu-cold-004&orientation=squarish',
        spicy: false
      },
      {
        name: 'Cold Jellyfish Salad',
        price: '16.00',
        description: 'Fresh jellyfish dressed in vinegar, sesame oil, and garlic. Crisp, light, and refreshing — a perfect summer cold dish.',
        image: 'https://readdy.ai/api/search-image?query=cold%20jellyfish%20salad%20with%20translucent%20jellyfish%20strips%20in%20sesame%20vinegar%20dressing%20on%20plate%20light%20background%20refreshing%20seafood%20cold%20dish&width=400&height=400&seq=menu-cold-005&orientation=squarish',
        spicy: false
      },
      {
        name: 'Spicy Lotus Root Slices',
        price: '11.00',
        description: 'Blanched lotus root slices tossed in spicy chili oil and Sichuan peppercorn dressing. Crisp, numbing, and full of flavor — a Sichuan cold dish specialty.',
        image: 'https://readdy.ai/api/search-image?query=spicy%20lotus%20root%20slices%20with%20thin%20crispy%20slices%20in%20red%20chili%20oil%20sichuan%20peppercorn%20dressing%20on%20plate%20light%20background%20sichuan%20cold%20dish&width=400&height=400&seq=menu-cold-006&orientation=squarish',
        spicy: true
      },
      {
        name: 'Vinegar-Glazed Peanuts',
        price: '9.00',
        description: 'Crispy fried peanuts tossed in aged vinegar, sugar, and garlic. Sweet, tangy, and crunchy — a classic Chinese appetizer and the perfect companion to drinks.',
        image: 'https://readdy.ai/api/search-image?query=vinegar%20peanuts%20with%20crispy%20fried%20peanuts%20in%20sweet%20sour%20vinegar%20dressing%20on%20plate%20light%20background%20classic%20chinese%20appetizer%20snack&width=400&height=400&seq=menu-cold-007&orientation=squarish',
        spicy: false
      },
      {
        name: 'Three-Shred Cold Salad',
        price: '12.00',
        description: 'Tofu skin, cucumber, and carrot cut into fine strips and tossed with sesame paste, garlic, and chili oil. Colorful, refreshing, and nutritionally balanced.',
        image: 'https://readdy.ai/api/search-image?query=cold%20three%20shreds%20salad%20with%20tofu%20skin%20cucumber%20carrot%20strips%20in%20sesame%20sauce%20dressing%20on%20plate%20light%20background%20colorful%20healthy%20cold%20dish&width=400&height=400&seq=menu-cold-008&orientation=squarish',
        spicy: false
      }
    ]
  }
];
